import React, { useState, useEffect } from 'react'

import App from './App'
import ModalAlert from './shared/ModalAlert'
import Modal from './shared/Modal'
import Loader from './shared/Loader'

export default function MyAccount({ appProps, screenClass, modules, getInstanceInfoPath, createInstancePath }) {
  const [modulesInfo, setModulesInfo] = useState({})
  const [instanceToCreate, setInstanceToCreate] = useState(null)
  const [createLoading, setCreateLoading] = useState(false)
  const [newTenantUrl, setNewTenantUrl] = useState(null)

  const loadedModulesCount = Object.keys(modulesInfo).length
  const availableModulesCount = modules.length
  const isLoadingModules = availableModulesCount > loadedModulesCount

  useEffect(()=> {
    modules.map((m, index) => {
      let formData = new FormData()
      formData.append('module', m.application_module)

      setTimeout(() => {
        Rails.ajax({
          type: 'POST',
          url: getInstanceInfoPath,
          dataType: 'json',
          data: formData,
          success: res => {
            setModulesInfo(prevState => {return {...prevState, [`${res.module}`]: res}})
          }
        })
      }, index * 500)
    })
  }, [])

  function createInstanceAction() {
    if(!instanceToCreate) {
      return
    }

    setCreateLoading(true)
    setInstanceToCreate(null)

    let formData = new FormData()
    formData.append('module', instanceToCreate.module)

    Rails.ajax({
      type: 'POST',
      url: createInstancePath,
      dataType: 'json',
      data: formData,
      success: res => {
        if(res.tenant_url) {
          setCreateLoading(false)
          setNewTenantUrl(res.tenant_url)
        }
      }
    })
  }

  function renderInstanceCard(m, index) {
    const moduleInfo = modulesInfo[m.application_module]

    return (
      <button
        key={ index }
        type='button'
        className={ `instance-card ${moduleInfo ? 'loaded' : 'loading'}` }
        disabled={ !moduleInfo }
        onClick={ () => moduleInfo && setInstanceToCreate(moduleInfo) }>
        { moduleInfo ?
          <>
            <span className='instance-card-glow'></span>
            <span className='instance-card-topline'>{ Cas.translations.create_instance_available_profile }</span>
            <span className='instance-card-media'>
              <img className='inst-image' src={ moduleInfo.app_interface_favicon || moduleInfo.favicon } />
            </span>
            <span className='instance-card-content'>
              <span className='inst-name'>{ moduleInfo.name || '' }</span>
              <span className='inst-description'>{ Cas.translations.create_instance_card_description }</span>
            </span>
            <span className='instance-card-action'>
              <span>{ Cas.translations.create_instance_create_action }</span>
              <i className='fa-light fa-arrow-right'></i>
            </span>
          </>
          :
          <span className='instance-card-loader'>
            <Loader size='medium' position='centered'/>
            <span>{ Cas.translations.create_instance_checking_availability }</span>
          </span>
        }
      </button>
    )
  }

  return (
    <App appProps={ appProps }>
      <div className={ `${screenClass}` }>
        <section className='create-instance-hero'>
          <div className='create-instance-hero-copy'>
            <div className='eyebrow'>{ Cas.translations.create_instance_eyebrow }</div>
            <h1>{ Cas.translations.sidenav_create_instance }</h1>
            <p>{ Cas.translations.create_instance_subtitle }</p>
          </div>
          <div className='create-instance-hero-panel'>
            <div className='hero-stat'>
              <span>{ loadedModulesCount }</span>
              <div>{ Cas.translations.create_instance_ready_flavors }</div>
            </div>
            <div className='hero-stat'>
              <span>{ availableModulesCount }</span>
              <div>{ Cas.translations.create_instance_allowed_network }</div>
            </div>
          </div>
        </section>

        <section className='create-instance-flow' aria-label={ Cas.translations.create_instance_flow_label }>
          <div className='flow-step active'>
            <i className='fa-light fa-grid-2'></i>
            <span>{ Cas.translations.create_instance_select_flavor }</span>
          </div>
          <div className='flow-line'></div>
          <div className='flow-step'>
            <i className='fa-light fa-envelope-circle-check'></i>
            <span>{ Cas.translations.create_instance_reuse_email }</span>
          </div>
          <div className='flow-line'></div>
          <div className='flow-step'>
            <i className='fa-light fa-arrow-up-right-from-square'></i>
            <span>{ Cas.translations.create_instance_open_account }</span>
          </div>
        </section>

        <section className='create-instance-wrapper'>
          <div className='section-heading'>
            <div>
              <div className='eyebrow'>{ Cas.translations.create_instance_dynamic_availability }</div>
              <h2>{ Cas.translations.create_instance_choose_next_account }</h2>
            </div>
            { isLoadingModules &&
              <div className='availability-pill'>
                <i className='fa-light fa-spinner-third'></i>
                <span>{ Cas.translations.create_instance_loading_flavors }</span>
              </div>
            }
          </div>

          { availableModulesCount > 0 ?
            <div className='instance-options'>
              { modules.map((m, index) => renderInstanceCard(m, index)) }
            </div>
            :
            <div className='create-instance-empty'>
              <i className='fa-light fa-circle-info'></i>
              <div>
                <h2>{ Cas.translations.create_instance_empty_title }</h2>
                <p>{ Cas.translations.create_instance_empty_description }</p>
              </div>
            </div>
          }
        </section>
      </div>

      { createLoading && <div className='create-loading-message'>{ Cas.translations.create_instance_creating_account }</div> }

      { instanceToCreate &&
        <ModalAlert
          alert={ <div>{ Cas.translations.create_instance_message_1 } <b>{ instanceToCreate.name }</b> { Cas.translations.create_instance_message_2 } <b>{ appProps.account.email }</b>. { Cas.translations.create_instance_message_3 }</div> }
          onSelect={ createInstanceAction }
          onClose={ () => setInstanceToCreate(null) }
        />
      }

      { newTenantUrl &&
        <Modal
          visible={ true }
          mode={ 'small' }
          closeModal={ () => {
            setNewTenantUrl(null)
          }}>
          <div className='flex-box flex-column items-center content-center'>
            <div style={{ fontSize: 15, marginBottom: 20 }}>{ Cas.translations.create_instance_completed }</div>
            <a className='button' href={ newTenantUrl } target='_blank' rel='nofollow noindex noreferrer'>
              { Cas.translations.access_new_account }
            </a>
          </div>
        </Modal>
      }

      { createLoading && <Loader position={'absolute'} size={ 'xlarge' } fullPage /> }
    </App>
  )
}
